angular.
module("digiexam.components").
directive("aDisabled", function aDisabledDirective() {
	"use strict";

	return {
		compile: function compile(tElement, tAttrs) {
			// Rewrite ngClick to not execute if disabled is truthy
			if (tAttrs.ngClick) {
				tAttrs.ngClick = "!(" + tAttrs.aDisabled + ") && (" + tAttrs.ngClick + ")";
			}

			return function postLink(scope, iElement, iAttrs) {
				scope.$watch(iAttrs.aDisabled, function watcher(newValue) {
					if (typeof newValue !== "undefined") {
						iElement.toggleClass("dx-disabled", newValue);
					}
				});

				iElement.on("click", function onClick(e) {
					if (scope.$eval(iAttrs.aDisabled)) {
						e.preventDefault();
					}
				});
			};
		},
	};
});
